<template>
  <el-popover popper-class="option-menu" v-model="visible" width="auto">
    <div class="option-wrap" @click="visible = false">
      <slot />
    </div>
    <div class="link-text option-menu-icon-title" slot="reference">
      <i class="icon" v-if="icon" :class="icon" :style="iconStyle"></i>
      <span v-if="title" v-text="title"></span>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: "OptionMenu",
  props: {
    icon: String,
    title: String,
    iconSize: [Number, String],
  },
  computed: {
    iconStyle() {
      return this.iconSize
        ? `font-size:${this.iconSize}px;line-height:16px`
        : "";
    },
  },
  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style lang="scss">
.option-menu {
  padding: 0 !important;
  min-width: auto !important;
  .option-wrap {
    padding: 5px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
.option-menu-icon-title {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
